import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

// CP-006: the piece pictures exactly as cut from real game screenshots (frontend/public/legion/gear/img/raw), untouched.
// They are added by Claude through change packets, so there is no upload here any more.
const SLOT = { hat: "Hat", neck: "Necklace", ring: "Ring", weapon: "Weapon", armor: "Armor" };
const TIER = { 3: "Gold", 2: "Silver", 1: "Bronze" };

export const AssetsTab = () => {
  const [rep, setRep] = useState(null);
  const [only, setOnly] = useState("all");
  useEffect(() => { api.get("/gear/assets-report").then((r) => setRep(r.data)).catch((e) => toast.error(errMsg(e))); }, []);

  if (!rep) return <p>Loading…</p>;
  const out = rep.pieces.filter((p) => !p.notOut);
  const have = out.filter((p) => p.have);
  const byTier = (t) => { const x = out.filter((p) => p.tier === t); return `${x.filter((p) => p.have).length} of ${x.length}`; };
  const shown = rep.pieces
    .filter((p) => (only === "missing" ? !p.have && !p.notOut : only === "have" ? p.have : only === "soon" ? p.notOut : true))
    .sort((a, b) => (a.notOut - b.notOut) || (b.tier || 0) - (a.tier || 0) || a.set.localeCompare(b.set) || Object.keys(SLOT).indexOf(a.slot) - Object.keys(SLOT).indexOf(b.slot));
  const gaps = rep.heroes.filter((h) => h.missing.length);
  return (
    <div data-testid="assets-tab">
      <p style={{ fontSize: 13.5 }}>
        The piece pictures exactly as cut from game screenshots, untouched. Gear cards use them inside the real picture frame. <b>{have.length} of {out.length}</b> released pieces have a picture
        {" "}(gold {byTier(3)} · silver {byTier(2)} · bronze {byTier(1)}).
      </p>
      <div className="lg-seg" style={{ marginBottom: 10 }}>
        {[["all", "All"], ["have", "In library"], ["missing", "Missing"], ["soon", "Not out yet"]].map(([k, l]) => <button key={k} className={only === k ? "on" : ""} onClick={() => setOnly(k)} data-testid={`assets-filter-${k}`}>{l}</button>)}
      </div>
      <div className="lg-assets">
        {shown.map((p) => (
          <div key={p.key} className={`lg-asset${p.have ? " have" : ""}${p.notOut ? " soon" : ""}`} data-testid={`asset-${p.key}`}>
            {p.have && p.url && <a href={p.url} target="_blank" rel="noreferrer"><img src={p.url} alt={`${p.set} ${SLOT[p.slot]}`} className="lg-asset-img" loading="lazy" data-testid={`asset-img-${p.key}`} /></a>}
            <b>{p.set}</b> <span>{SLOT[p.slot]}{p.tier ? ` · ${TIER[p.tier]}` : ""}</span>
            <small>{p.notOut ? "Not out yet" : p.have ? (p.neededBy ? `used by ${p.neededBy} heroes` : "in library") : `missing${p.neededBy ? ` · needed by ${p.neededBy} heroes` : ""}`}</small>
          </div>
        ))}
      </div>
      <h4 style={{ marginTop: 18 }}>Hero profiles with gaps ({gaps.length})</h4>
      <p style={{ fontSize: 12.5, color: "var(--muted)" }}>
        {Object.entries(gaps.reduce((a, h) => { h.missing.forEach((m) => { a[m] = (a[m] || 0) + 1; }); return a; }, {})).map(([k, n]) => `${k}: ${n}`).join(" · ")}
      </p>
      <h4 style={{ marginTop: 18 }}>Asset template</h4>
      {Object.entries(rep.template).map(([k, items]) => (
        <div key={k} className="lg-card" style={{ padding: 12, marginBottom: 8 }} data-testid={`asset-template-${k.replace(/ /g, "-")}`}>
          <b>When a {k} comes out, we need:</b>
          <ul style={{ margin: "6px 0 0", paddingLeft: 18, fontSize: 13 }}>{items.map((i) => <li key={i}>{i}</li>)}</ul>
        </div>
      ))}
    </div>
  );
};
